<script lang="ts">
	import { cart } from '$lib/stores';
	import toast from '@toast';

	export let id: number,
		price: number,
		discount: number,
		name: string,
		image_url_0: string | null = null;

	const addToCart = (): void => {
		cart.update((previousData) => {
			const index = previousData.findIndex((pd) => pd.id === id);
			if (index !== -1) {
				previousData[index].amount++;
			} else {
				previousData.push({ id, name, amount: 1, image_url_0, price, discount, weight: null });
			}

			return previousData;
		});

		toast.success(`${name} agregado al carrito`);
	};
</script>

<button
	on:click={addToCart}
	class="btn variant-ringed-primary hover:variant-ghost-primary duration-200 {$$props.class}"
>
	Agregar al carrito
</button>
